module.exports = __webpack_public_path__ + "media/10.5be30fa6.wav";